import { ApiUtility } from "../Utilities/ApiUtility.axios";

class CleanCatchService {
    route = `/API/CleanCache`;

    postCleanCache = () => ApiUtility.post(`${this.route}/InvalidateCache`, {});
}

export default new CleanCatchService();